/**
 * Toast Notifications
 */

import Toasted from 'vue-toasted';
import Vue from 'vue';
import store from '@/store/index';


Vue.use(Toasted, {
    duration: 4000,
    closeOnSwipe: true,
    singleton: true,
});

// This is how we register different type of Toast notifications
const toastCallback = ({ name, defaultMessage, options }) => {
    Vue.toasted.register(name, payload => {
        if (!payload.message) {
            return store.$i18n.t(defaultMessage);
        }

        return payload.message;
    }, {
        keepOnHover: true,
        duration: 4000,
        singleton: true,
        closeOnSwipe: true,
        ...options,
    });
};

[
    {
        name: 'toast_error',
        defaultMessage: 'toastMessage.defaultError',
        options: {
            type: 'error',
            icon: 'error',
            position: 'top-right',
        },
    },
    {
        name: 'toast_success',
        defaultMessage: 'toastMessage.defaultSuccess',
        options: {
            type: 'success',
            icon: 'assignment_turned_in',
            position: 'top-center',
        },
    },
    {
        name: 'toast_info',
        defaultMessage: '',
        options: {
            type: 'info',
            icon: 'info',
            position: 'top-center',
        },
    },
].forEach(toastCallback);

export default {};

// TODO:: register Toast for completed Action
// Type of the Toast ['success', 'info', 'error']
